import React from 'react';

import { formatMoney } from '@betterment/core';
import { Box, Text } from '@betterment/samba-react';

import { HighlightRow, Purpose, formatDate } from './HighlightRow';

import { ProjectedBalanceTooltip } from '../ProjectedBalanceTooltip';

export const RetirementGrowthHighlights: React.FC<{ purpose: Purpose<'PurposeRetirementGrowth'> }> = ({ purpose }) => {
  const { retirementGrowthProjection: projection, targetMonthlySpendingAmount } = purpose;
  const timeSeries = projection?.balanceTimeSeries;
  if (!timeSeries) return null;

  const finalPoint = timeSeries?.[timeSeries.length - 1];

  return (
    <>
      <HighlightRow>
        <HighlightRow.Leading>
          <Box css={{ display: 'flex', gap: 'space.50' }}>
            <Text variant="text100">Projected balance</Text>
            <ProjectedBalanceTooltip />
          </Box>
          <Text variant="text50" color="text.weak">
            {formatDate(finalPoint.date)}
          </Text>
        </HighlightRow.Leading>
        <HighlightRow.Trailing>
          <Text variant="text100">{formatMoney(finalPoint.expected)}</Text>
        </HighlightRow.Trailing>
      </HighlightRow>
      <HighlightRow>
        <HighlightRow.Leading>
          <Text variant="text100">Spending power</Text>
          <Text variant="text50" color="text.weak">
            In today's dollars
          </Text>
        </HighlightRow.Leading>
        <HighlightRow.Trailing>
          <Text variant="text100">{formatMoney(projection.monthlySpendingAmount)}</Text>
          <Text variant="text50" color="text.weak">
            Per month
          </Text>
        </HighlightRow.Trailing>
      </HighlightRow>
      {targetMonthlySpendingAmount && (
        <HighlightRow>
          <HighlightRow.Leading>
            <Text variant="text100">Desired spending power</Text>
            <Text variant="text50" color="text.weak">
              In today's dollars
            </Text>
          </HighlightRow.Leading>
          <HighlightRow.Trailing>
            <Text variant="text100">{formatMoney(targetMonthlySpendingAmount)}</Text>
            <Text variant="text50" color="text.weak">
              Per month
            </Text>
          </HighlightRow.Trailing>
        </HighlightRow>
      )}
    </>
  );
};
